/* eslint-disable */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-undef */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faCheck,
  faFilter,
  faFileExcel,
  faClose,
} from '@fortawesome/free-solid-svg-icons';
import { useTable } from 'react-table';
import Lottie from 'lottie-react';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import Swal from 'sweetalert2';
import { isNotNullUndefinedOrEmpty } from '../../../components/Validators';
import { getAllRegionalHeadIndentsApprovals, updateRegionalHeadHnlRequests, updateHnlIndentRequests, exporRegionalHeadHnlIndentingApproval, getPlantAndMaterialCodes } from '../../../store/modules/product/actions';
import {
  selectIsLoading,
  selectProducts,
} from '../../../store/modules/product/selectors';
import { ToastContainer, toast } from 'react-toastify';
import Search from '../../../components/Search';
import LoadingModal from '../../../components/LoadingModal';
import withScreenRefreshDetection from '../../../utils/withScreenRefreshDetection';
import EmptyInventory from '../../../assets/animations/EmptyInventory.json';
import '../Hnlindenting.scss';

const Tickets = (props) => {
  const dispatch = useDispatch();
  const role = localStorage.getItem('role');
  const [query, setQuery] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [storePageSizeValue, setStorePageSizeValue] = useState(30);
  const [pageNum, setPageNum] = useState(1);
  const [products, setProducts] = useState([]);
  const [productsController, setProductsController] = useState({
    thresholds: {},
    quantities: {},
    vehicleNumber: {},
    driverMobileNumber: {},
    requiredDate: {},
    dispatchDate: {},
    dispatchQuantity: {}
  });
  const data = useSelector((state) => selectProducts(state));
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedClusters, setSelectedClusters] = useState([]);
  const [plantCode, setPlantCode] = useState(null);
  const [materialCode, setMaterialCode] = useState(null);
  const [feedType, setFeedType] = useState(null);
  const [feedTypes, setFeedTypes] = useState([]);
  const [plantCodes, setPlantCodes] = useState([]);
  const [materialCodes, setMaterialCodes] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const values = {
          ...(role === 'hnl-admin'
            ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
            : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
          ),
        }
        const response = await dispatch(getPlantAndMaterialCodes(values));
        console.log('Fetched data:', response);

        if (response) {
          const { plantCodes, materialCodes, feedTypes } = response;
          setPlantCodes(plantCodes);
          setMaterialCodes(materialCodes);
          setFeedTypes(feedTypes);
        }
      } catch (error) {
        console.error('Error fetching plant and material codes:', error);
      }
    };

    fetchData();
  }, [dispatch]);

  const handleCallBack = (response, cluster = null, clusterMap = null) => {
    // console.log('cluster Map:', clusterMap);
    if (role === 'regional_pi')
      showCapacityDifferece(response?.data, cluster, clusterMap)
    setSelectedClusters([]);
    if (response) {
      const values = {
        page: pageNum,
        limit: storePageSizeValue,
        ...(role === 'hnl-admin'
          ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
          : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
        ),
        plantCode,
        materialCode,
        feedType,
      };
      dispatch(getAllRegionalHeadIndentsApprovals(values));
    }
  };

  const handleButtonClick = async (
    material, thresholdValue, quantityValue, vehicleNumber,
    driverMobileNumber, requiredDate, dispatchDate, dispatchQuantity,
    role, status
  ) => {
    const cluster = material?.cluster; // <— grab cluster here

    if (role === 'hnl-admin') {
      quantityValue = dispatchQuantity;
    }

    if (status === 'approved' && requiredDate == undefined && role === 'regional_pi') {
      alert("Please enter Required date");
      return;
    }
    if (status === 'approved' && quantityValue === "0" && role === 'regional_pi') {
      alert("Indent quantity should be more than zero");
      return;
    } else if (status === 'approved' && quantityValue === "" && role === 'regional_pi') {
      alert("Please enter indent quantity");
      return;
    }

    if (status === 'approved') {
      const values = {
        id: material?.id,
        cluster, // <— include if you want it in the payload too
        threshold: thresholdValue,
        indentQuantity: quantityValue ? quantityValue : material?.indentQuantity,
        ...(role === 'hnl-admin'
          ? { hnlStatus: status, vehicleNumber, driverMobileNumber, dispatchDate, dispatchQuantity }
          : { rHStatus: status, requiredDate }
        ),
      };

      const array = [
        Object.entries(values)
          .filter(([_, value]) => isNotNullUndefinedOrEmpty(value))
          .reduce((acc, [key, value]) => { acc[key] = value; return acc; }, {}),
      ];

      Swal.fire({
        title: 'Confirm Approval?',
        text: `Are you sure you want to approve the ${material?.materialName ?? 'current item'}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          // wrap the callback so it receives cluster
          const cb = (resp) => handleCallBack(resp, cluster);
          dispatch(
            role === 'hnl-admin'
              ? updateHnlIndentRequests(array, cb)
              : updateRegionalHeadHnlRequests(array, cb)
          );
        }
      });

    } else {
      Swal.fire({
        title: `Why reject ${material?.materialName ?? 'current item'}? Can you share your reasons?`,
        input: 'textarea',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Submit',
      }).then((result) => {
        if (result?.isConfirmed) {
          if (result?.value) {
            const values = {
              id: material?.id,
              threshold: thresholdValue,
              indentQuantity: quantityValue,
              ...(role === 'hnl-admin'
                ? { hnlStatus: status }
                : { rHStatus: status }
              ),
              comment: result?.value,
            };
            const array = [
              Object.entries(values)
                .filter(([_, value]) => isNotNullUndefinedOrEmpty(value))
                .reduce((acc, [key, value]) => {
                  acc[key] = value;
                  return acc;
                }, {}),
            ];
            dispatch(role === 'hnl-admin' ? updateHnlIndentRequests(array, handleCallBack) : updateRegionalHeadHnlRequests(array, handleCallBack));
          } else {
            Swal.fire({
              title: 'Please enter the reason for rejection',
              icon: 'warning',
              toast: true,
            });
          }
        }
      });
    }
  };


  const checkPlantCapacity = async (material, array) => {
    const { plantCode, uom } = material;
    const { indentQuantity } = array[0];
    const values = { indentQuantity, plantCode, uom };
  }

  const exportExcell = () => {
    const status = tabIndex === 0 ? 'pending' : 'approved';
    dispatch(exporRegionalHeadHnlIndentingApproval({ status, plantCode, materialCode, feedType, startDate, endDate }));
  };

  const handleOnFilter = async () => {
    const { value: formValues } = await Swal.fire({
      title: 'Enter Plant Code & Material Code',
      html: `
        <select id="swal-input1" class="swal2-input" style="width: 100%">
          <option value="">Select Plant Code</option>
          ${plantCodes.map(item => `<option value="${item}" ${item === plantCode ? 'selected' : ''}>${item}</option>`).join('')}
        </select>
        <select id="swal-input3" class="swal2-input" style="width: 100%">
          <option value="">Select Feed Type</option>
          ${feedTypes.map(item => `<option value="${item}" ${item === feedType ? 'selected' : ''}>${item}</option>`).join('')}
        </select>
         <select id="swal-input2" class="swal2-input" style="width: 100%">
          <option value="">Select Material Code</option>
          ${materialCodes.map(item => `<option value="${item}" ${item === materialCode ? 'selected' : ''}>${item}</option>`).join('')}
        </select>
      `,
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      footer: `
        <button id="clear-filters" style="
          background-color: #d33;
          color: white;
          border: none;
          border-radius: 5px;
          padding: 10px 24px;
          font-size: 16px;
          cursor: pointer;
          margin-top: 10px;
        ">Clear Filters</button>
      `,
      focusConfirm: false,
      preConfirm: () => {
        const input1 = document.getElementById('swal-input1').value;
        const input2 = document.getElementById('swal-input2').value;
        const input3 = document.getElementById('swal-input3').value;
        if (!input1 && !input2 && !input3) {
          Swal.showValidationMessage('At least one field must be filled');
          return null;
        }
        return [input1, input2, input3];
      },
      didRender: () => {
        document.getElementById('clear-filters').addEventListener('click', () => {
          clearFilters();
          Swal.close();
        });
      }
    });

    if (formValues) {
      setPlantCode(formValues[0]);
      setMaterialCode(formValues[1]);
      setFeedType(formValues[2]);
      const values = {
        page: pageNum,
        limit: storePageSizeValue,
        ...(role === 'hnl-admin'
          ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
          : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
        ),
        plantCode: formValues[0],
        materialCode: formValues[1],
        feedType: formValues[2]
      };
      dispatch(getAllRegionalHeadIndentsApprovals(values));
    }
  };

  const getReports = async (values = {}) => {
    try {
      const response = await dispatch(getAllRegionalHeadIndentsApprovals(values));
      // if (response) {
      //   if (showPlantWise) setData(response);
      //   else setRegionData(response);
      // }
    } catch (error) {
      console.error('Error fetching Summary Report:', error);
    }
  };

  // useEffect(() => {
  //   if (showPlantWise) {
  //     getReports({ plant: 'plant' });
  //   } else {
  //     getReports();
  //   }
  // }, []);

  const clearFilter = () => {
    setStartDate(null);
    setEndDate(null);
    getReports();
  };

  const handleDateRange = async () => {
    const { value: formValues } = await Swal.fire({
      title: 'Please select dates',
      html: `
          <div class="dropdown-container">
             <div class="date-range-container">
            <label for="start-date">Start Date:</label>
            <input type="date" id="start-date" class="swal2-input" value=${startDate}>
            <br>
            <label for="end-date">End Date:</label>
            <input type="date" id="end-date" class="swal2-input" value=${endDate}>
          </div>
        `,
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      footer: `
          <button id="clear-filters" style="
            background-color: #d33;
            color: white;
            border: none;
            border-radius: 5px;
            padding: 10px 24px;
            font-size: 16px;
            cursor: pointer;
            margin-top: 10px;
          ">Clear Filters</button>
        `,
      focusConfirm: false,
      preConfirm: () => {
        const input1 = document.getElementById('start-date').value;
        const input2 = document.getElementById('end-date').value;

        if (!input1) {
          Swal.showValidationMessage('Select start date');
        } else if (!input2) {
          Swal.showValidationMessage('Select end date');
        }
        return [input1, input2];
      },
      didRender: () => {
        document.getElementById('clear-filters').addEventListener('click', () => {
          clearFilter();
          Swal.close();
        });
      },
    });

    if (formValues) {
      setStartDate(formValues[0]);
      setEndDate(formValues[1]);
      const values = {
        page: pageNum,
        limit: storePageSizeValue,
        startDate: formatDate(formValues[0]),
        endDate: formatDate(formValues[1]),
        ...(role === 'hnl-admin'
          ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
          : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
        ),
      };
      getReports(values);
    }
  };

  const clearFilters = () => {
    setPlantCode(null);
    setMaterialCode(null);
    setFeedType(null);
    const values = {
      page: pageNum,
      limit: storePageSizeValue,
      ...(role === 'hnl-admin'
        ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
        : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
      ),
      plantCode: null,
      materialCode: null,
      feedType: null
    };
    dispatch(getAllRegionalHeadIndentsApprovals(values));
  };

  const handleInputChange = (row, key, value) => {
    const updatedState = { ...productsController };
    updatedState[key][row.original.id] = value;

    setProductsController((prevState) => ({
      ...prevState,
      ...updatedState,
    }));

    const newData = { ...data };
    const updatedRow = { ...row.original, [key]: value };
    const updatedPaginate = newData?.paginate?.map((rowData) => (rowData.id === updatedRow.id ? updatedRow : rowData));
    newData.paginate = updatedPaginate;
    setProducts(newData);
  };
  const today = new Date();
  const todayString = today.toISOString().split('T')[0];

 const columns = useMemo(() => {
  const checkboxColumn = {
    Header: (
      <input
        type="checkbox"
        checked={selectAll}
        onChange={(e) => {
          const { checked } = e.target;
          setSelectAll(checked);
          if (checked) {
            setSelectedRows(data.paginate.map((row) => row.id));
            setSelectedClusters(data.paginate.map((row) => row.cluster));
          } else {
            setSelectedRows([]);
            setSelectedClusters([]);
          }
        }}
      />
    ),
    accessor: "select",
    Cell: ({ row }) => (
      <input
        type="checkbox"
        checked={selectedRows.includes(row.original.id)}
        onChange={(e) => {
          const { checked } = e.target;
          if (checked) {
            setSelectedRows([...selectedRows, row.original.id]);
            setSelectedClusters([...selectedClusters, row.original.cluster]);
          } else {
            setSelectedRows(selectedRows.filter((id) => id !== row.original.id));
            setSelectedClusters(
              selectedClusters.filter((c) => c !== row.original.cluster)
            );
          }
        }}
      />
    ),
  };

  const actionColumn = {
    Header: "ACTION TO BE TAKEN",
    Cell: ({ row }) => (
      <div className="buttons">
        <button
          type="button"
          className="mini-button green"
          onClick={() =>
            handleButtonClick(
              row?.original,
              productsController?.thresholds[row.original.id],
              productsController?.quantities[row?.original?.id],
              productsController?.vehicleNumber[row?.original?.id],
              productsController?.driverMobileNumber[row?.original?.id],
              productsController?.requiredDate[row?.original?.id],
              productsController?.dispatchDate[row?.original?.id],
              productsController?.dispatchQuantity[row.original.id],
              role,
              "approved"
            )
          }
        >
          <FontAwesomeIcon icon={faCheck} />
        </button>
        <button
          type="button"
          className="mini-button danger"
          onClick={() =>
            handleButtonClick(
              row?.original,
              productsController?.thresholds[row.original.id],
              productsController?.quantities[row?.original?.id],
              productsController?.vehicleNumber[row?.original?.id],
              productsController?.driverMobileNumber[row?.original?.id],
              productsController?.quantities[row?.original?.id],
              productsController?.dispatchDate[row?.original?.id],
              productsController?.dispatchQuantity[row.original.id],
              role,
              "rejected"
            )
          }
        >
          <FontAwesomeIcon icon={faClose} />
        </button>
      </div>
    ),
  };

  const commonColumns = [
    {
      Header: "ORDER ID",
      accessor: "id",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: "INDENT ID",
      accessor: "indentId",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    ...(role === "hnl-admin"
      ? [
          {
            Header: "ORDER DATE",
            accessor: "orderedDate",
            Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
          },
        ]
      : []),
    {
      Header: "REGION NAME",
      accessor: "regionName",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: "CLUSTER NAME",
      accessor: "cluster",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: "PLANT CODE",
      accessor: "plantCode",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: "PLANT NAME",
      accessor: "plantName",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: () => (
        <span>
          REQUIRED DATE <span className="required-mark">*</span>
        </span>
      ),
      accessor: "requiredDate",
      Cell: ({ row }) => {
        const tat = parseInt(row?.original?.tatInDays, 10) || 0;
        const today = new Date();
        const minDate = new Date();
        minDate.setDate(today.getDate() + tat + 1);
        const formattedMinDate = minDate.toISOString().split("T")[0];

        return role === "regional_pi" ? (
          <input
            type="date"
            className="form__field"
            value={
              productsController?.requiredDate[row?.original?.id] ??
              row?.original?.requiredDate
            }
            onChange={(e) =>
              handleInputChange(row, "requiredDate", e.target.value)
            }
            min={formattedMinDate}
            required
          />
        ) : (
          <p>{row?.original?.requiredDate}</p>
        );
      },
    },
    {
      Header: "PRODUCT CATEGORY",
      accessor: "type",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: "PRODUCT NAME",
      accessor: "materialName",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: "MATERIAL CODE",
      accessor: "materialCode",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: "UNIT OF MEASUREMENT",
      accessor: "uom",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: "INDENT QUANTITY",
      accessor: "indentQuantity",
      Cell: ({ row }) =>
        role === "hnl-admin" ? (
          <p>{row?.original?.currentQuantity}</p>
        ) : (
          <input
            type="number"
            className="form__field"
            value={
              productsController?.quantities[row?.original?.id] ??
              row?.original?.indentQuantity
            }
            onChange={(e) =>
              handleInputChange(row, "quantities", e.target.value)
            }
          />
        ),
    },
    ...(role === "hnl-admin"
      ? [
          {
            Header: "DISPATCH QUANTITY",
            accessor: "dispatchQuantity",
            Cell: ({ row }) => (
              <input
                className="form__field"
                value={
                  productsController?.dispatchQuantity[row?.original?.id] ??
                  row?.original?.dispatchQuantity
                }
                onChange={(e) =>
                  handleInputChange(row, "dispatchQuantity", e.target.value)
                }
              />
            ),
          },
        ]
      : []),
    {
      Header: "CURRENT INVENTORY",
      accessor: "ohs",
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    ...(role === "hnl-admin"
      ? [
          {
            Header: "SUGGESTED TRUCK",
            accessor: "truckCapacity",
            Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
          },
          {
            Header: "VEHICLE NUMBER",
            accessor: "vehicleNumber",
            Cell: ({ row }) => (
              <input
                className="form__field"
                value={
                  productsController?.vehicleNumber[row?.original?.id] ??
                  row?.original?.vehicleNumber
                }
                onChange={(e) =>
                  handleInputChange(row, "vehicleNumber", e.target.value)
                }
              />
            ),
          },
          {
            Header: "DRIVER MOBILE NUMBER",
            accessor: "driverMobileNumber",
            Cell: ({ row }) => (
              <input
                className="form__field"
                value={
                  productsController?.driverMobileNumber[row?.original?.id] ??
                  row?.original?.driverMobileNumber
                }
                onChange={(e) =>
                  handleInputChange(row, "driverMobileNumber", e.target.value)
                }
              />
            ),
          },
          {
            Header: "DISPATCH DATE",
            accessor: "dispatchDate",
            Cell: ({ row }) => (
              <input
                type="date"
                className="form__field"
                value={
                  productsController?.dispatchDate[row?.original?.id] ??
                  row?.original?.dispatchDate
                }
                onChange={(e) =>
                  handleInputChange(row, "dispatchDate", e.target.value)
                }
                min={todayString}
              />
            ),
          },
        ]
      : []),
  ];

  if (role === "hnl-admin") {
    return [checkboxColumn, ...commonColumns, actionColumn];
  } else if (role === "regional_pi") {
    return [...commonColumns, checkboxColumn];
  } else {
    return commonColumns;
  }
}, [selectAll, selectedRows, data, role]);


  const finishedColumns = useMemo(
    () => [{
      Header: 'ORDER ID',
      accessor: 'id',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    }, {
      Header: 'INDENT ID',
      accessor: 'indentId',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'ORDER DATE',
      accessor: 'orderedDate',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
      // Cell: ({ value }) => (value !== null ? <p>{formatDate(value)}</p> : ""),
    },
    {
      Header: 'REGION NAME',
      accessor: 'regionName',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'CLUSTER NAME',
      accessor: 'cluster',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'PLANT CODE',
      accessor: 'plantCode',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'PLANT NAME',
      accessor: 'plantName',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'REQUIRED DATE',
      accessor: 'requiredDate',
      Cell: ({ value }) => {
        if (!value) return "";

        const date = new Date(value);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return <p>{`${day}-${month}-${year}`}</p>;
      },
    },
    {
      Header: 'PRODUCT CATEGORY',
      accessor: 'type',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'PRODUCT NAME',
      accessor: 'materialName',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'MATERIAL CODE',
      accessor: 'materialCode',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'UNIT OF MEASUREMENT',
      accessor: 'uom',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'SUGGESTED TRUCK',
      accessor: 'truckCapacity',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'INDENT QUANTITY',
      accessor: 'currentQuantity',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'DISPATCH QUANTITY',
      accessor: 'dispatchQuantity',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'VEHICLE NUMBER',
      accessor: 'vehicleNumber',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'DRIVER MOBILE NUMBER',
      accessor: 'driverMobileNumber',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'REJECTED REASON',
      accessor: 'comment',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'DISPATCH DATE',
      accessor: 'dispatchDate',
      Cell: ({ value }) => (value !== null ? <p>{value}</p> : ""),
    },
    {
      Header: 'REGIONAL STATUS',
      accessor: 'rHStatus',
      Cell: ({ value }) => (value !== null ? (
        <p style={{
          color:
            value === 'pending'
              ? '#ffb100'
              : value === 'rejected'
                ? 'red'
                : 'green',
        }}
        >
          {value}
        </p>
      ) : <p>N/A</p>),
    }, {
      Header: 'HNL STATUS',
      accessor: 'hnlStatus',
      Cell: ({ value }) => (value !== null ? (
        <p style={{
          color:
            value === 'pending'
              ? '#ffb100'
              : value === 'rejected'
                ? 'red'
                : 'green',
        }}
        >
          {value}
        </p>
      ) : <p>N/A</p>),
    },
    {
      Header: 'OVERALL STATUS',
      accessor: 'status',
      Cell: ({ value }) => (value !== null ? (
        <p style={{
          color:
            value === 'pending'
              ? '#ffb100'
              : value === 'rejected'
                ? 'red'
                : 'green',
        }}
        >
          {value}
        </p>
      ) : <p>N/A</p>),
    }],
    [],
  );

  const isLoading = useSelector((state) => selectIsLoading(state));

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns: tabIndex === 0 ? columns : finishedColumns,
    data:
       data && data?.paginate && data?.paginate?.length
      ? data?.paginate
          .map((item) => ({
            ...item,
            phone: item?.phone?.replace('+91', ''),
          }))
          .sort((a, b) => {
            // Convert orderDate to Date objects for proper comparison
            const dateA = new Date(a.orderDate);
            const dateB = new Date(b.orderDate);
            return dateB - dateA; // descending: recent first
          })
      : [],
  });

  const nextPage = (page) => {
    setPageNum(page);
    const nextPageVal = {
      page,
      limit: storePageSizeValue,
      ...(role === 'hnl-admin'
        ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
        : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
      ),
      plantCode,
      materialCode,
      feedType,
      startDate,
      endDate,
    };
    dispatch(getAllRegionalHeadIndentsApprovals(nextPageVal));
  };

  const previousPage = (page) => {
    setPageNum(page);
    const prevPageVal = {
      page,
      limit: storePageSizeValue,
      ...(role === 'hnl-admin'
        ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
        : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
      ),
      plantCode,
      materialCode,
      feedType,
    };
    dispatch(getAllRegionalHeadIndentsApprovals(prevPageVal));
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setQuery(value);
  };

  const search = () => {
    const values = {
      prodName: query,
      page: pageNum,
      limit: storePageSizeValue,
      ...(role === 'hnl-admin'
        ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
        : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
      ),
    };
    setPlantCode(null);
    setMaterialCode(null);
    setFeedType(null);
    dispatch(getAllRegionalHeadIndentsApprovals(values));
  };

  const pageSize = Array.from({ length: 10 }, (_, index) => (index + 1) * 30);
  const handleOnPageSizeSelected = (event) => {
    const newSize = Number(event?.target?.value);
    setStorePageSizeValue(newSize);
    const values = {
      page: pageNum,
      limit: newSize,
      ...(role === 'hnl-admin'
        ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
        : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
      ),
      plantCode,
      materialCode,
      feedType,
      startDate,
      endDate,
    };
    dispatch(getAllRegionalHeadIndentsApprovals(values));
  };

  const handleOnBulkApproval = (event) => {
    // Assuming you can resolve clusters per id
    // If you already have materials in scope, adapt this lookup accordingly.
    // const clusterMap = Object.fromEntries(
    //   selectedRows.map((id) => [id, (materialsById?.[id] || productsController?.materials?.[id])?.cluster])
    // );

    // console.log('Cluster Map:', selectedRows, productsController);
    const array = selectedRows.map((id) => {
      const thresholdValue = productsController?.thresholds[id] ?? data?.paginate?.find(item => item.id === id)?.threshold;
      const quantityValue = productsController?.quantities[id] ?? data?.paginate?.find(item => item.id === id)?.indentQuantity;
      const vehicleNumber = productsController?.vehicleNumber[id] ?? data?.paginate?.find(item => item.id === id)?.vehicleNumber;
      const driverMobileNumber = productsController?.driverMobileNumber[id] ?? data?.paginate?.find(item => item.id === id)?.driverMobileNumber;
      const requiredDate = productsController?.requiredDate[id] ?? data?.paginate?.find(item => item.id === id)?.requiredDate;
      const dispatchDate = productsController?.dispatchDate[id] ?? data?.paginate?.find(item => item.id === id)?.dispatchDate;
      const dispatchQuantity = productsController?.dispatchQuantity[id] ?? data?.paginate?.find(item => item.id === id)?.dispatchQuantity;

      return {
        id,
        threshold: thresholdValue,
        indentQuantity: quantityValue,
        vehicleNumber,
        driverMobileNumber,
        requiredDate,
        dispatchDate,
        dispatchQuantity,
        ...(role === 'hnl-admin' ? { hnlStatus: event } : { rHStatus: event }),
      };
    });
    console.log('Bulk update array:', array);
    let invalidEntries = [];
    let alertMessage = '';
    if (role === 'regional_pi') {
      invalidEntries = array.filter(item => !item.requiredDate || item.indentQuantity === null || item.indentQuantity == 0);
      alertMessage = 'Some items have missing or invalid required dates or indent quantities. Please correct them before proceeding.';
    }

    if (invalidEntries.length > 0) {
      Swal.fire({
        title: 'Invalid Entries Detected',
        text: alertMessage,
        icon: 'error',
        confirmButtonColor: '#d33',
        confirmButtonText: 'OK',
      });
      return;
    }

    if (event === 'approved') {
      Swal.fire({
        title: 'Confirm Approval?',
        text: 'Are you sure you want to approve all the selected items?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          // wrap callback to provide the whole cluster map (or a parallel array)
          const cb = (resp) => handleCallBack(resp, null, selectedClusters);
          dispatch(
            role === 'hnl-admin'
              ? updateHnlIndentRequests(array, cb)
              : updateRegionalHeadHnlRequests(array, cb)
          );
        }
      });
    } else {
      Swal.fire({
        title: 'Why reject all these items? Can you share a valid reason?',
        input: 'textarea',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Submit',
      }).then((result) => {
        if (result.isConfirmed) {
          if (result.value) {
            const rejectionArray = selectedRows.map((id) => {
              const thresholdValue = productsController?.thresholds[id];
              const quantityValue = productsController?.quantities[id];
              return {
                id,
                threshold: thresholdValue,
                indentQuantity: quantityValue,
                ...(role === 'hnl-admin'
                  ? { hnlStatus: event }
                  : { rHStatus: event }
                ),
                comment: result.value,
              };
            });
            dispatch(role === 'hnl-admin' ? updateHnlIndentRequests(rejectionArray, handleCallBack) : updateRegionalHeadHnlRequests(rejectionArray, handleCallBack));
          } else {
            Swal.fire({
              title: 'You lack a valid rejection reason. Please try again.',
              icon: 'warning',
              toast: true,
            });
          }
        }
      });
    }
  };

  const arrayOfButtons = [
    {
      id: 0,
      name: 'Approve',
      className: 'button green',
      onClick: () => handleOnBulkApproval('approved'),
    },
    {
      id: 1,
      name: 'Reject',
      className: 'button danger',
      onClick: () => handleOnBulkApproval('rejected'),
    },
  ];

  useEffect(() => {
    setPlantCode(null);
    setMaterialCode(null);
    setFeedType(null);
    const values = {
      page: 1,
      limit: 30,
      ...(role === 'hnl-admin'
        ? { hnlStatus: tabIndex === 0 ? 'pending' : 'approved' }
        : { rHStatus: tabIndex === 0 ? 'pending' : 'approved' }
      ),
    };
    dispatch(getAllRegionalHeadIndentsApprovals(values));
  }, [dispatch, tabIndex]);

 const showCapacityDifferece = async (data, cluster = null, clusterMap = null, delay = 1000) => {
  setSelectedRows([]);
  const normalize = (c) => String(c).trim().toLowerCase();
  const hasClusterMap = Array.isArray(clusterMap) && clusterMap.length > 0;

  const uniqueClusterKeys = hasClusterMap
    ? Array.from(new Set(clusterMap.filter(Boolean).map(normalize)))
    : [];

  if (!cluster && uniqueClusterKeys.length === 0) {
    return;
  }

  // Parse truck capacity (supports "30 + 10")
  const parseTruckCapacity = (capacity) => {
    if (!capacity) return { total: 0, breakdown: "0", trucks: [] };
    if (typeof capacity === "number")
      return { total: capacity, breakdown: `${capacity}`, trucks: [capacity] };

    const parts = String(capacity)
      .split("+")
      .map((p) => parseFloat(p.trim()))
      .filter((n) => !isNaN(n));

    const total = parts.reduce((a, b) => a + b, 0);
    return { total, breakdown: parts.join(" + "), trucks: parts };
  };

  const formatTruckMessage = (trucks, total) => {
      if (trucks.length === 1) {
      return `One <b>${trucks[0]}-ton</b> truck has been assigned`;
    }
    const truckList = trucks
      .map((t) => `one <b>${t}-ton</b> truck`)
      .join(" and ");
    return `${trucks.length} trucks are assigned: ${truckList} (total <b>${total} tons</b>).`;
  };

  const showAlert = (clusterName, status, gap, truckCapacity, totalLoad) => {
    const { total, trucks } = parseTruckCapacity(truckCapacity);
    const truckMsg = formatTruckMessage(trucks, total);

    let title = "";
    let message = "";
    let type = "success";

    if (status === "stop") {
      title = `${clusterName} - Action Required`;
      message = `${truckMsg}, but we still have <b>${gap} tons</b> of space not filled. Add more indent to submit the order.`;
      type = "info";
    } else if (status === "overflow") {
      title = `${clusterName} - Action Required`;
      message = `Could not raise the indent due to exceeding the assigned capacity by <b>${Math.abs(
        gap
      )} tons</b>! ${truckMsg} Please adjust the quantities accordingly.`;
      type = "warning";
    } else if (status === "proceed") {
      title = `${clusterName} - Success`;
      message = `Indent raised successfully for a load of <b>${totalLoad} tons</b>. ${truckMsg}`;
      type = "success";
    }

    Swal.fire({
      title,
      html: message,
      icon: type,
      confirmButtonColor: type === "warning" || type === "error" ? "#d33" : "#3085d6",
      confirmButtonText: "OK",
    });
  };

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  if (uniqueClusterKeys.length > 0) {
    for (const key of uniqueClusterKeys) {
      const summaryItem = data.summary.find(
        (item) => item.cluster && item.cluster.toLowerCase() === key
      );

      if (!summaryItem) {
        toast(`No summary found for cluster: ${key}`, { type: toast.TYPE.WARNING });
        continue;
      }

      const { truckCapacity, totalLoad, status, cluster: displayName } = summaryItem;
      const { total } = parseTruckCapacity(truckCapacity);
      const gap = total - totalLoad;

      showAlert(displayName || key, status, gap, truckCapacity, totalLoad);
      await wait(delay);
    }
  } else if (cluster) {
    const summaryItem = data.summary.find(
      (item) => item.cluster && item.cluster.toLowerCase() === normalize(cluster)
    );

    if (!summaryItem) {
      toast(`No summary found for cluster: ${cluster}`, { type: toast.TYPE.WARNING });
      return;
    }

    const { truckCapacity, totalLoad, status } = summaryItem;
    const { total } = parseTruckCapacity(truckCapacity);
    const gap = total - totalLoad;

    showAlert(summaryItem.cluster, status, gap, truckCapacity, totalLoad);
  }
};








  return (
    <div className="hnl-indenting-dashboard">
      <div className="row middle">
        <div className="col-12 col-md-10">
          {/* <Search
            value={query}
            label="Find Farmers By Name, Vendor Code, or Phone"
            onChangeText={handleChange}
            onSubmit={handleOnSearch}
          /> */}
        </div>
        <ToastContainer />
        <div className="col-12 col-md-2">
          <div className="buttons">
            <button
              type="button"
              className="button danger"
              onClick={handleDateRange}
            >
              <FontAwesomeIcon icon="fa-solid fa-calendar-range" />
              Date Range
            </button>
            <button
              type="button"
              className="button primary"
              onClick={handleOnFilter}
            >
              <FontAwesomeIcon icon={faFilter} className="button__icon" />
              Filter
            </button>
            <button type="button" className="button green" onClick={exportExcell}>
              <FontAwesomeIcon icon={faFileExcel} className="button__icon" />
              Export
            </button>
          </div>
        </div>
      </div>
      <Tabs
        selectedIndex={tabIndex}
        onSelect={(index) => setTabIndex(index)}
      >
        <h4>NOTE: Feed in Bags & Feed supplements are in Kgs or Ltrs</h4>
        <TabList className="row between tab-list">
          <Tab className="col-6 tab">
            <div className={`type-card ${tabIndex === 0 ? 'selected' : ''}`}>
              Ongoing Inventory
            </div>
          </Tab>
          <Tab className="col-6 tab">
            <div className={`type-card ${tabIndex === 1 ? 'selected' : ''}`}>
              Finished Inventory
            </div>
          </Tab>
        </TabList>
        <TabPanel className="order-tab-panel">
          <div className="row end">
            {selectedRows?.length > 0 ? (
              <div className="col-12 col-md-2">
                <div className="buttons">
                  {arrayOfButtons
                    ?.filter((item) => {
                      if (item?.name === 'Ticket' && role !== 'call_center') {
                        return false;
                      }
                      return true;
                    })
                    .map((item) => (
                      <button
                        key={item?.id}
                        type="button"
                        className={item?.className}
                        onClick={item?.onClick}
                      >
                        {item?.name}
                      </button>
                    ))}
                </div>
              </div>
            ) : null}
          </div>
          <div className="table-container">
            {data && data?.paginate?.length > 0 ? (
              <div className="row">
                <div className="col-12">
                  <div className="table-footer">
                    <div className="row middle">
                      <div className="col-12 col-md-6">
                        <span className="table-footer__title">
                          {data && data.Previous
                            ? (data.Previous.page + 1) * data.Previous.limit
                            - data.Previous.limit
                            + 1
                            : 1}
                          {' '}
                          to
                          {' '}
                          {data && data.Previous
                            ? (data.Previous.page + 1) * data.Previous.limit
                            : storePageSizeValue}
                          {' '}
                          {' '}
                          {`of ${pageNum}`}
                          {' '}
                          {''}
                          <span className="form__label">Page Size 2 : </span>
                          <select
                            onChange={handleOnPageSizeSelected}
                            className="dropdown-menu"
                          >
                            {pageSize?.map((item, index) => (
                              <option
                                key={index.toString()}
                                value={item}
                                className="dropdown-menu"
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        </span>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="table-footer__buttons">
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => previousPage(1)}
                            disabled={!data || !data.Previous}
                          >
                            <FontAwesomeIcon
                              icon={faAngleDoubleLeft}
                              className="table-footer__button__icon"
                            />
                          </button>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => (data ? previousPage(data.Previous.page) : {})}
                            disabled={!data || !data.Previous}
                          >
                            <FontAwesomeIcon
                              icon={faAngleLeft}
                              className="table-footer__button__iclon"
                            />
                          </button>
                          <div className="table-footer__label">
                            {data && data.Next
                              ? data.Next.page - 1
                              : data && data.Previous
                                ? data.Previous.page + 1
                                : 1}
                          </div>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => (data ? nextPage(data.Next.page) : {})}
                            disabled={!data || !data.Next}
                          >
                            <FontAwesomeIcon
                              icon={faAngleRight}
                              className="table-footer__button__icon"
                            />
                          </button>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => (data ? nextPage(data.Next.page) : {})}
                            disabled={!data || !data.Next}
                          >
                            <FontAwesomeIcon
                              icon={faAngleDoubleRight}
                              className="table-footer__button__icon"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <table {...getTableProps()} className="table table-bordered">
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup?.headers?.map((column, index) => (
                            <th
                              key={index.toString()}
                              {...column.getHeaderProps()}
                              style={{ fontSize: 12 }}
                            >
                              {column.render('Header')}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {rows.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row?.cells?.map((cell) => (
                              <td
                                {...cell.getCellProps()}
                                style={{ fontSize: 13, fontWeight: 400 }}
                              >
                                {cell.render('Cell')}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="row middle h-200">
                <div className="d-flex-col center">
                  <Lottie animationData={EmptyInventory} loop={false} className="noUsersIcon" />
                  <p className="noRecordsFound">No Records Found</p>
                </div>
              </div>
            )}
          </div>
        </TabPanel>
        <TabPanel className="order-tab-panel">
          <div className="table-container">
            {data && data?.paginate?.length > 0 ? (
              <div className="row">
                <div className="col-12">
                  <div className="table-footer">
                    <div className="row middle">
                      <div className="col-12 col-md-6">
                        <span className="table-footer__title">
                          {data && data.Previous
                            ? (data.Previous.page + 1) * data.Previous.limit
                            - data.Previous.limit
                            + 1
                            : 1}
                          {' '}
                          to
                          {' '}
                          {data && data.Previous
                            ? (data.Previous.page + 1) * data.Previous.limit
                            : storePageSizeValue}
                          {' '}
                          {' '}
                          {`of ${pageNum}`}
                          {' '}
                          {''}
                          <span className="form__label">Page Size 1: </span>
                          <select
                            onChange={handleOnPageSizeSelected}
                            className="dropdown-menu"
                          >
                            {pageSize?.map((item, index) => (
                              <option
                                key={index.toString()}
                                value={item}
                                className="dropdown-menu"
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        </span>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="table-footer__buttons">
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => previousPage(1)}
                            disabled={!data || !data.Previous}
                          >
                            <FontAwesomeIcon
                              icon={faAngleDoubleLeft}
                              className="table-footer__button__icon"
                            />
                          </button>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => (data ? previousPage(data.Previous.page) : {})}
                            disabled={!data || !data.Previous}
                          >
                            <FontAwesomeIcon
                              icon={faAngleLeft}
                              className="table-footer__button__iclon"
                            />
                          </button>
                          <div className="table-footer__label">
                            {data && data.Next
                              ? data.Next.page - 1
                              : data && data.Previous
                                ? data.Previous.page + 1
                                : 1}
                          </div>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => (data ? nextPage(data.Next.page) : {})}
                            disabled={!data || !data.Next}
                          >
                            <FontAwesomeIcon
                              icon={faAngleRight}
                              className="table-footer__button__icon"
                            />
                          </button>
                          <button
                            type="button"
                            className="table-footer__button"
                            onClick={() => (data ? nextPage(data.Next.page) : {})}
                            disabled={!data || !data.Next}
                          >
                            <FontAwesomeIcon
                              icon={faAngleDoubleRight}
                              className="table-footer__button__icon"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <table {...getTableProps()} className="table table-bordered">
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup?.headers?.map((column, index) => (
                            <th
                              key={index.toString()}
                              {...column.getHeaderProps()}
                              style={{ fontSize: 12 }}
                            >
                              {column.render('Header')}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {rows.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row?.cells?.map((cell) => (
                              <td
                                {...cell.getCellProps()}
                                style={{ fontSize: 13, fontWeight: 400 }}
                              >
                                {cell.render('Cell')}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="row middle h-200">
                <div className="d-flex-col center">
                  <Lottie animationData={EmptyInventory} loop={false} className="noUsersIcon" />
                  <p className="noRecordsFound">No Records Found</p>
                </div>
              </div>
            )}
          </div>
        </TabPanel>
      </Tabs>
      <LoadingModal show={isLoading} />
    </div>
  );
};

export default withScreenRefreshDetection(Tickets);